import { Injectable } from '@angular/core';
import { CacheService } from '../shared/services/cache.service';
import {
  LoggerService,
  OrderApi,
  OrganizationApi,
  LoopBackConfig,
  Order,
  Document,
} from '../shared/sdk';
import { ToastService } from '../shared/modules/toast/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../shared/services/api.service';
import { BASE_URL, API_VERSION } from '../shared/base-url';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OrderService extends ApiService<Order> {
  constructor(
    protected cacheService: CacheService,
    protected log: LoggerService,
    protected toastService: ToastService,
    protected translate: TranslateService,
    private orderApi: OrderApi,
    private orgApi: OrganizationApi,
  ) {
    super(cacheService, log, toastService, translate);

    this.name = 'Order';
    this.plural = 'Orders';

    LoopBackConfig.setBaseURL(BASE_URL);
    LoopBackConfig.setApiVersion(API_VERSION);
  }

  count(
    orgId: string,
    filter: any = {},
    force = false,
    toastr = true,
  ): Observable<number> {
    return super.count(orgId, filter, force, toastr, this.orgApi);
  }

  createDocument(
    id: string,
    type: string,
    send?: boolean,
  ): Observable<Document> {
    return this.orderApi.remoteCreateDocument(id, type, send);
  }

  get(
    orgId: string,
    filter: any = {},
    force = false,
    toastr = true,
  ): Observable<{ body: Order[]; totalCount: number }> {
    return super.get(orgId, filter, force, toastr, this.orgApi);
  }

  getById(
    id: string,
    filter = {},
    force = true,
    toastr = true,
  ): Observable<Order> {
    return super.getById(id, filter, force, toastr, this.orderApi);
  }

  exportForDeliveryService(
    organizationId: string,
    deliveryService: string,
    filter: Record<string, any> = {},
    lang,
  ) {
    return super.downloadDeferred(
      this.orgApi.export(organizationId, 'order', filter, null, lang, {
        deliveryService,
      }),
    );
  }
}
